import React, { useState } from "react";
import LineupPitch from "./LineupPitch";
import PlayerSheet from "./PlayerSheet";
import { useLineups } from "./useMatchData";

/** Lineup tab body: recorded formation pitch, tap a player for the match sheet. */
export default function MatchLineups({ fixtureId, providerFixtureId, fallbackLineups, events, isAdmin, analyticsAllowed = isAdmin, pitchMatchId, onNavigate }) {
  const { loading, lineups, predicted, error } = useLineups(fixtureId, fallbackLineups);
  const [selection, setSelection] = useState(null);
  if (loading) return <div className="fa-skeleton" role="status" aria-label="Loading lineups" style={{ height: 320 }} />;
  if (error) return <div className="fa-empty">{error}</div>;
  return (
    <>
      <LineupPitch lineups={lineups} events={events} predicted={predicted} onSelectPlayer={setSelection} />
      {selection && (
        <PlayerSheet
          selection={selection}
          fixtureId={fixtureId}
          providerFixtureId={providerFixtureId}
          isAdmin={isAdmin}
          analyticsAllowed={analyticsAllowed}
          pitchMatchId={pitchMatchId}
          onNavigate={onNavigate}
          onClose={() => setSelection(null)}
        />
      )}
    </>
  );
}
